import { Injectable } from '@angular/core';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { FormGroup } from '@angular/forms';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';

/**
 * A command class, which handles a changes of UnloadType input for Colombia
 */
@Injectable()
export class HandleCoUnloadTypeCommand implements OnFieldChanged {
  onFieldChanged(value: string, formGroup: FormGroup, form: ConfigurableFormComponent): void {
    this.resetPumpForm(formGroup);
  }

  private resetPumpForm(formGroup: FormGroup): void {
    formGroup.get(SpecFieldNames.PUMP).setValue(undefined);
    formGroup.get(SpecFieldNames.PIPE_QUANTITY).setValue(0);
  }
}
